import { render } from "./GetItems.vue?vue&type=template&id=56105f18"
import script from "./GetItems.vue?vue&type=script&lang=js"
export * from "./GetItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__